import Helper from './Helper';

class Tabs {
  constructor(config = {}) {
    const {
      tabContainerSelector,
      tabSelector,
    } = config;
    this.tabSelector = tabSelector;
    this.tabContainer = document.querySelectorAll(tabContainerSelector);
    this.tabs = document.querySelectorAll(tabSelector);

    this.tabsArray = Array.prototype.slice.call(this.tabs);
    this.tabContainerArray = Array.prototype.slice.call(this.tabContainer);

    if(this.tabContainer){
      this.tabContainerArray.forEach(tabContainer => {
        if(Helper.isDesktop()){
          this.setUpTabs(tabContainer);
        }
      });

      this.bindEvents();
    }
  }

  setUpTabs(container){
    const tabs = Array.prototype.slice.call(container.querySelectorAll(this.tabSelector));

    const navigator = document.createElement('div');
    Helper.addClass(navigator, 'ns-tab-navigator');

    tabs.forEach((tab, i) => {
      const title = tab.querySelector('.ns-tab__tab-title');
      if(i == 0){
        Helper.addClass(tab, 'active');
        Helper.addClass(title, 'active');
      }
      navigator.appendChild(title);
    });
    container.insertBefore(navigator, container.firstChild);
  }

  bindEvents(){
    this.tabContainerArray.forEach(container => {
      const tabLinks = Array.prototype.slice.call(container.querySelectorAll('.ns-tab__tab-title'));
      const tabs = Array.prototype.slice.call(container.querySelectorAll(this.tabSelector));
      tabLinks.forEach((link, i) => {
        link.addEventListener('click', e => {
          if(Helper.isDesktop()){
            tabLinks.forEach(tab => {
              Helper.removeClass(tab, 'active');
            });
            tabs.forEach(tab => {
              Helper.removeClass(tab, 'active');
            });
            Helper.addClass(link, 'active');
            Helper.addClass(tabs[i], 'active');
          } else {
            Helper.toggleClass(link, 'active');
            Helper.toggleClass(tabs[i], 'active');
          }
        });
      });
    });
  }
}

export default Tabs;
